import {
  ANSWER_MODE_THREADS_ENDPOINT,
  ANSWER_MODE_THREAD_ENDPOINT,
} from 'api/constants';
import { api } from 'store/api/api';

import type {
  AnswerThread,
  AnswerThreadsList,
} from './answer-threads.api.types';

const answerThreadsApi = api
  .enhanceEndpoints({
    addTagTypes: ['AnswerModeThreads', 'AnswerModeThread'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAnswerThreads: builder.query<AnswerThreadsList, void>({
        query: () => ({
          url: ANSWER_MODE_THREADS_ENDPOINT,
          method: 'GET',
          credentials: 'include',
        }),
        providesTags: ['AnswerModeThreads'],
        keepUnusedDataFor: 60,
      }),
      getAnswerThread: builder.query<AnswerThread, { threadId: string }>({
        query: ({ threadId }) => ({
          url: ANSWER_MODE_THREAD_ENDPOINT.replace(':threadId', threadId),
          method: 'GET',
          credentials: 'include',
        }),
        providesTags: (_, __, { threadId }) => [
          { type: 'AnswerModeThread', id: threadId },
        ],
        keepUnusedDataFor: 60,
      }),
      deleteAnswerThread: builder.mutation<void, { threadId: string }>({
        query: ({ threadId }) => ({
          url: ANSWER_MODE_THREAD_ENDPOINT.replace(':threadId', threadId),
          method: 'DELETE',
          credentials: 'include',
        }),
        invalidatesTags: (_, __, { threadId }) => [
          { type: 'AnswerModeThread', id: threadId },
          'AnswerModeThreads',
        ],
      }),
    }),
  });

export const {
  useGetAnswerThreadsQuery,
  useLazyGetAnswerThreadQuery,
  useDeleteAnswerThreadMutation,
} = answerThreadsApi;
